var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91797 8.7513C2.37437 8.7513 2.10257 8.7513 1.88817 8.66249C1.60231 8.54409 1.37519 8.31697 1.25678 8.0311C1.16797 7.8167 1.16797 7.5449 1.16797 7.0013V3.03464C1.16797 2.38124 1.16797 2.05454 1.29513 1.80498C1.40698 1.58546 1.58546 1.40698 1.80498 1.29513C2.05454 1.16797 2.38124 1.16797 3.03464 1.16797H7.0013C7.5449 1.16797 7.8167 1.16797 8.0311 1.25678C8.31697 1.37519 8.54409 1.60231 8.66249 1.88817C8.7513 2.10257 8.7513 2.37437 8.7513 2.91797M7.11797 12.8346H10.968C11.6214 12.8346 11.9481 12.8346 12.1976 12.7075C12.4171 12.5956 12.5956 12.4171 12.7075 12.1976C12.8346 11.9481 12.8346 11.6214 12.8346 10.968V7.11797C12.8346 6.46457 12.8346 6.13788 12.7075 5.88831C12.5956 5.66879 12.4171 5.49031 12.1976 5.37846C11.9481 5.2513 11.6214 5.2513 10.968 5.2513H7.11797C6.46457 5.2513 6.13788 5.2513 5.88831 5.37846C5.66879 5.49031 5.49031 5.66879 5.37846 5.88831C5.2513 6.13788 5.2513 6.46457 5.2513 7.11797V10.968C5.2513 11.6214 5.2513 11.9481 5.37846 12.1976C5.49031 12.4171 5.66879 12.5956 5.88831 12.7075C6.13788 12.8346 6.46457 12.8346 7.11797 12.8346Z",
    stroke: "#182230",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCopy);
export default __webpack_public_path__ + "static/media/icons-copy.11042e0f401dc1e4dac32eb9fee10dc2.svg";
export { ForwardRef as ReactComponent };